import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import { DashboardTile, ErrorType } from 'commons/src/models/commonTypeScript';
import Error from '../../components/error';
import PublicDashboardHeader from '../../components/pageHeader/PublicDashboardHeader';
import { publicDashboardPlaceholder } from '../../components/placeholder';
import { Store } from '../../reducers';
import { PublicRequestType } from '../../reducers/requestReducer';
import PublicDashboardTiles from './PublicDashoardTiles';

export type Props = {
    tiles: DashboardTile[];
    loading: boolean;
    error?: ErrorType;
    tilesLoading: boolean;
    tilesError?: ErrorType;
    numberOfTilesInWidth: number;
};

export const PublicDashboardViewComponent = (props: Props): React.ReactElement => {
    const { loading, numberOfTilesInWidth, tiles, tilesLoading, error, tilesError } = props;
    const loadingPage = loading || (tilesLoading && tiles.length === 0);
    const errorText = (error && error.error) || (tilesError && tilesError.error);
    const displayError = error || (tilesError && tiles.length === 0);
    if (displayError) {
        return (
            <Error
                errorHeader="PublicIAQDashboard.DashboardNotPublic"
                errorText={`ErrorCodes.${errorText}`}
                errorIcon="visibility_off"
            />
        );
    }
    return (
        <ReactPlaceholder ready={!loadingPage} customPlaceholder={publicDashboardPlaceholder}>
            <PublicDashboardHeader />
            <PublicDashboardTiles tiles={tiles} numberOfTilesInWidth={numberOfTilesInWidth} />
        </ReactPlaceholder>
    );
};

const mapStateToProps = (state: Store): Props => {
    const {
        publicDashboard: { tiles },
        publicRequests: {
            [PublicRequestType.FetchPublicDashboard]: { loading, error },
            [PublicRequestType.FetchPublicDashboardTiles]: { loading: tilesLoading, error: tilesError },
        },
        publicUserPreferences: { numberOfTilesInWidth },
    } = state;
    return {
        numberOfTilesInWidth,
        tiles,
        tilesLoading,
        tilesError,
        loading,
        error,
    };
};

export default connect(mapStateToProps)(PublicDashboardViewComponent);
